import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { AUTH_INDICATOR } from '../enums/auth-indicator.enum';
import { LocalStorageService } from '../services/localstorage.service';
import { IndicadorEnum } from '../enums/indicador.enum';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private dialogRef;
  constructor(private storage: LocalStorageService,
              private marketplaceRedirectService: MarketplaceRedirectService,
              private dialogService: DialogService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      let data;
      switch (err.status) {
        case 403:
          if (!this.dialogRef) {
            this.dialogRef = this.dialogService.refreshTokenDialog();
            this.dialogRef.afterClosed().subscribe(() => {
              this.storage.resertApp();
              location.reload();
              this.dialogRef = undefined;
              return;
            });
          }
          break;
        case 500:
        case 503:
         
        const codeError = err.error.mensaje && err.error.mensaje.contenido && err.error.mensaje.contenido.includes("#CODE#") ? err.error.mensaje.contenido.split("#CODE#")[1]:"";
        if(codeError){
          
            data = {
                title: 'Ups, parece que hubo un error',
                description: 'En este momento, nuestra página está presentando problemas. Por favor, intenta más tarde.',
                actionButton: 'Entendido',
                icon: './assets/icons/ovni_error.svg',
                errorCode:"ERROR :" + codeError.split(":").join("")

              };
              this.dialogService.closeProcesoSegundoPlanoDialog();
              this.dialogService.openDialogError({ data }).afterClosed().subscribe(() => {
                   this.marketplaceRedirectService.redirectPortalPublico();
              });
              return;
        }

            data = {
              title: 'Lo sentimos',
              description: 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.',
              actionButton: 'Ir a Portal Público',
              icon: null
            };

            this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe((response) => {
                if (_.get(response, 'action') === 'OK') {
                  this.marketplaceRedirectService.redirectPortalPublico();
                  return;
                }else{
                  return false;
                }
            });
        

      
  
          break;
        case 400:
          if(err.error.indicador && err.error.indicador == AUTH_INDICATOR.PRODUCTO_SELECCIONADO_VACIO){
            data = {
              title: 'Seleccionar un producto',
              description: 'Para ser cliente Transbank, primero debes seleccionar un producto de nuestra tienda.',
              actionButton:'Ir a Tienda',
              icon: null
            };
            this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe((response) => {
                if (_.get(response, 'action') === 'OK') {
                  this.marketplaceRedirectService.redirect();
                  return;
                }else{
                  this.marketplaceRedirectService.redirect();
                  return;
                }
            });
            break;
          }
        default:
          console.error("Intercept Error", err);
          return throwError(err);

      }
    }));
  }


}
